import gen from "@assets/icons/reset.svg";
import { IContractValue } from "@components/global/new/ContractSelector/ContractSelector.props";
import CustomerSelector from "@components/global/new/CustomerSelector/CustomerSelector";
import Error from "@components/global/new/Error/Error";
import FieldBage from "@components/global/new/FieldBage/FieldBage";
import Title from "@components/global/new/Title/Title";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import styles from "./CreateContractModal.module.scss";
import { useCreateContractControl } from "./useCreateContractControl";
import { Button } from "antd";
import { Input } from "@components/global/new/Input/Input";
import { RedoOutlined } from "@ant-design/icons";
import classNames from "classnames";
import { useMiningPlans } from "@utils/hooks/useMiningPlans";
import { Select } from "@components/global/new/Select/Select";
import decodeHTMLEntities from "@utils/decodeHTMLEntities";
import { formatUser } from "@components/global/new/CustomerSelector/CustomerSelector.service";

export interface ICreactContractProps extends CommonModalPropsI {
  onResult?(id: IContractValue): void;
}

function CreateContractModal(props: ICreactContractProps) {

  const { formatMessage } = props;
  const control = useCreateContractControl(props);
  const plansCache = useMiningPlans();
  console.log(plansCache);

  return (
    <div className={styles.wrapper}>
      <Title className={styles.title}>{formatMessage({ id: "modal.create_contract.title" })}</Title>

      <div className={styles.content}>
        <form className={styles.content__form} onSubmit={control.formControl}>
          <Input
            size="small"
            label={<span className={styles.label}>{formatMessage({ id: "contracts.info.name" })}</span>}
            type='text'
            id="name"
            wrapClassName={classNames(styles.content__form__item, { [styles.inputError]: !!control.errors.name })}
          />
          <Select
            size="small"
            label={<span className={styles.label}>{formatMessage({ id: "contracts.info.client" })}</span>}
            id="customer"
            wrapClassName={styles.content__form__item}
            allowClear={true}
            options={control.users
              .map((p) => ({
                label: formatUser(p, formatMessage),
                value: p.id
              }))}
          />
          <FieldBage
            name={formatMessage({ id: "contracts.info.electro_cost" })}
            bage={formatMessage({ id: "contracts.info.electro_cost__bage" })}
            className={styles.content__form__item}
            id='consumption'
            isError={!!control.errors.price}
            up
          />
          <Select
            size="small"
            label={<span className={styles.label}>{formatMessage({ id: "machines.settings.plan" })}</span>}
            id="plan"
            wrapClassName={styles.content__form__item}
            allowClear
            options={plansCache.map(item => ({
              label: decodeHTMLEntities(item.name),
              value: item.id,
            }))}
          />
          <Input
            size="small"
            label={<span className={styles.label}>{formatMessage({ id: "contracts.info.password" })}</span>}
            type='text'
            id={"password"}
            value={control.generated}
            wrapClassName={classNames(styles.content__form__item, { [styles.inputError]: !!control.errors.pass })}
            //isError={!!control.errors.pass}
            copyButton
          />
          <div className={styles.random} onClick={control.onGenerate}>
            <span>{formatMessage({ id: "modal.new_client.generate" })}</span>{" "}
            <RedoOutlined />
          </div>

          {(control.errors.name ||
            control.errors.pass ||
            control.errors.price) && <Error errors={{ fill: true }} />}

          <div className={styles.btns}>
            <Button onClick={props.handleClose}>
              {formatMessage({ id: "modal.change_pass.cancel" })}
            </Button>
            <Button htmlType="submit" type="primary" loading={control.isLoading}>
              {formatMessage({ id: "modal.create_plan.btn.create" })}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default WithModal(
  MODALS_ENUM.CREATE_CONTRACT_MODAL,
  CreateContractModal
);
